import React from 'react';
import { Link } from 'react-router-dom';

const tabs = [
  { name: 'Account', href: '/dashboard/einstellungen' },
  { name: 'Sicherheit', href: '/dashboard/sicherheit' },
];

const SettingsNav = ({ current }) => {
  return (
    <header className="border-b border-white/5">
      <nav className="flex overflow-x-auto py-4">
        <ul
          role="list"
          className="flex min-w-full flex-none gap-x-6 px-4 text-sm font-semibold leading-6 text-gray-700 sm:px-6 lg:px-8"
        >
          {tabs.map((tab) => (
            <li key={tab.name}>
              <Link
                to={tab.href}
                className={tab.name === current ? 'text-svisit-primary-400' : ''}
              >
                {tab.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default SettingsNav;
